export const fetchFullContact = async (
  picked: server.dto.ContactSmallV2 | null
): Promise<server.dto.Contact | null> => {
  if (picked == null) return null;
  const res = await window.CoreApi.Contact.GetSidePanelData(picked.contactId);
  return res.data.data.contact;
};

export const fetchFullCompany = async (
  picked: server.dto.CompanySmall | null
): Promise<server.dto.Company | null> => {
  if (picked == null) return null;
  const res = await window.CoreApi.Company.GetSidePanelData(picked.companyId);
  return res.data.data.company;
};